// @flow
import React, { useEffect } from 'react';
import Checkbox from 'material-ui/Checkbox';
import { useForm, Controller } from 'react-hook-form';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { PasswordGenerator } from '../password-generator/password-generator';

export const UserForm = ({ user, onSubmit, serverError, isCreation = false, children }) => {
	const {
		control,
		setError,
		formState: { errors },
		handleSubmit,
	} = useForm();

	useEffect(() => {
		if (serverError !== null) {
			const {field, ...error} = serverError;
			setError(field, error);
		}
	}, [serverError])

	const emailErrorText = errors.email
		? (errors.email.type === 'pattern' ? 'Неверный формат поля' : errors.email.message || 'Email обязательно для заполнения')
		: '';

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Controller
				name="name"
				control={control}
				rules={{ required: true }}
				defaultValue={user.name || ''}
				render={({ field: { onChange, value } }) => (
					<TextField
						onChange={onChange}
						errorText={errors.name ?  'Имя обязетельно для заполнения' : ''}
						floatingLabelText="Фамилия"
						value={value}
						fullWidth={true}
						floatingLabelFixed={true}
					/>
				)}
			/>
			{isCreation && (
				<Controller
					name="password"
					control={control}
					rules={{ required: true }}
					defaultValue=""
					render={({ field: { onChange, value } }) => (
						<PasswordGenerator
							includeSymbols={false}
							includeLowercase={true}
							value={value}
							onChange={onChange}
							includeUppercase={true}
							includeNumbers={true}
							passwordLength={12}
						/>
					)}
				/>
			)}

			<Controller
				name="email"
				control={control}
				rules={{ required: true, pattern: /^\S+@\S+$/i }}
				defaultValue={user.email || ''}
				render={({ field: { onChange, value } }) => (
					<TextField
						floatingLabelText="Email"
						errorText={emailErrorText}
						onChange={onChange}
						value={value}
						fullWidth={true}
						floatingLabelFixed={true}
					/>
				)}
			/>

			<Controller
				name="blocked"
				control={control}
				defaultValue={user.blocked || false}
				render={({ field: { onChange, value } }) => <Checkbox label="Blocked" onCheck={onChange} checked={value} />}
			/>

			<Controller
				name="canDelete"
				control={control}
				defaultValue={user.canDelete || false}
				render={({ field: { onChange, value } }) => <Checkbox label="Can Delete" onCheck={onChange} checked={value} />}
			/>

			<Controller
				name="active"
				control={control}
				defaultValue={user.true || true}
				render={({ field: { onChange, value } }) => <Checkbox label="Active" onCheck={onChange} checked={value} />}
			/>

			<div style={{ display: 'flex', marginTop: 20 }}>
				<RaisedButton
					label="Сохранить"
					type={'submit'}
					primary={true}
				/>
				{children}
			</div>

		</form>
	);
};



// WEBPACK FOOTER //
// src/components/users/UserForm.js